module.exports = __webpack_public_path__ + "static/media/Step4.d8163652.svg";